// Facturación por Segmento — sum of invoiced amounts (con IVA) for invoices
// dated in the period, minus notas de crédito dated in it, pivoted by
// segment × CP/LP. Incluye la facturación de
// rentas cubiertas con unidades subarrendadas (que no tienen fila en `cars`).
import supabase from "../../../supabase-client";

const fmtMoney = (v) => "$" + Math.round(Number(v) || 0).toLocaleString("es-MX");

export const invoicingBySegmentReport = {
  id: "invoicing-by-segment",
  title: "Facturación por Segmento",
  description: "Monto facturado (con IVA) por segmento de auto y sucursal en el periodo, menos notas de crédito. Incluye unidades subarrendadas.",
  category: "Finanzas",
  filters: [
    { type: "daterange", fromKey: "from", toKey: "to", label: "Periodo", required: true },
  ],
  pivot: {
    rowKey: "segment",
    colKey: "branch",
    valueKey: "value",
    rowLabel: "Facturación",
    rowOrder: ["Carga", "Pasajeros", "Sedanes"],
    colOrder: ["CP", "LP"],
    format: fmtMoney,
    exportType: "currency",
  },
  async fetch({ from, to }) {
    if (!from || !to) throw new Error("Seleccionar periodo");
    const { data, error } = await supabase.rpc("report_invoicing_segment", {
      p_from: from, p_to: to,
    });
    if (error) throw error;
    return data || [];
  },
};
